import { PaginationState, RowSelectionState } from "@tanstack/react-table"

import { useCustomReactTable } from "~/components/hooks/useCustomReactTable"
import { ProductTraceabilityListItemResponseDto } from "~/gen/api"
import { useProductsTraceabilityColumns } from "~/pages/Brand/Products/List/Components/ProductsTables/traceability/traceability-columns"

export type Props = {
  pagination: PaginationState
  rowSelection: RowSelectionState
  setPagination: React.Dispatch<React.SetStateAction<PaginationState>>
  setRowSelection: React.Dispatch<React.SetStateAction<RowSelectionState>>
  pageCount: number
  maxRank: number
  showOnlyMainFabric: boolean
  products: ProductTraceabilityListItemResponseDto[]
}

export const useTraceabilityTable = ({
  pagination,
  rowSelection,
  setPagination,
  setRowSelection,
  pageCount,
  maxRank,
  showOnlyMainFabric,
  products,
}: Props) => {
  const columns = useProductsTraceabilityColumns(maxRank, showOnlyMainFabric)

  const table = useCustomReactTable({
    data: products || [],
    columns,
    initialColumnPinning: {
      left: [
        "traceabilityStatus",
        "traceabilityLaunchedAt",
        "name",
        "brandReference",
      ],
    },
    state: {
      pagination,
      rowSelection,
    },
    pageCount,
    manualPagination: true,
    enableRowSelection: true,
    onPaginationChange: setPagination,
    onRowSelectionChange: setRowSelection,
  })

  return table
}
